module.exports = {"id":"183540","name":"Barry Bannan","rating":"72","photo":"./data/images/photos/3/183540.png","club":{"name":"Sheffield Wed.","logo":"./data/images/clubs/SheffieldWed..png"},"positions":["MC","MG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BarryBannan0.json
// module id = 534
// module chunks = 0